import {
  HttpTransportType,
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { useCallback, useEffect, useState } from 'react';

export default function useModulePermissionHub(token: string | null) {
  const [connection, setConnection] = useState<HubConnection | null>(null);
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const connect = useCallback(async () => {
    if (token) {
      try {
        const hubConnection = new HubConnectionBuilder()
          .withUrl(
            `${process.env.REACT_APP_APIBaseUrl}/hubs/modulePermissionsHub`,
            {
              accessTokenFactory: () => token,
              transport: HttpTransportType.WebSockets,
            }
          )
          .configureLogging(LogLevel.None)
          .withAutomaticReconnect()
          .build();

        hubConnection.on('connected', (modules: any[]) => {
          console.log(modules);
          setData(modules);
        });

        hubConnection.on('ReceiveModules', (modules: any[]) => {
          setData(modules);
        });

        await hubConnection.start();
        setConnection(hubConnection);
        setIsLoading(false);
      } catch (err) {
        setIsError(true);
        setError(err);
        setIsLoading(false);
      }
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      connect();
    } else {
      setConnection(null);
      setIsLoading(false);
    }

    return () => {
      if (connection) {
        connection.stop().catch((err: any) => {
          console.error('Error stopping connection:', err);
        });
      }
    };
  }, [token]);

  return { data, isLoading, isError, error };
}
